import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { crmConstants, crmModels } from '..';

export const useLeadEmployeeAll = (props: { enabled?: boolean } = {}) => {
  const data = useQuery<crmModels.ILeadEmployee[]>({
    queryKey: [crmConstants.queryKeys.LEAD_EMPLOYEE_ALL],
    queryFn: async () => {
      const res = await $api.get('/v1/lead/employee/all');

      return res?.data?.data;
    },
    enabled: props?.enabled,
    staleTime: Infinity
  });

  return {
    ...data,
    employeeObj: (data?.data || [])?.reduce<Record<string, crmModels.ILeadEmployee>>(
      (p, c) => ({ ...p, [c?.id]: c }),
      {}
    )
  };
};
